import React from 'react'
import LearningPathGrades from 'src/modules/MyClass/LearningPathGrades'

const LearningPathGradesPage = () => {
  return <LearningPathGrades />
}

export default LearningPathGradesPage
